"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var styles_1 = require("styles");
var componentStyle = {
    td: {
        padding: '8px 10px',
        fontWeight: 100,
    },
    name: {
        color: styles_1.FontColor.Blue,
    },
    type: {
        color: styles_1.FontColor.Red,
    },
    defaultValue: {
        color: styles_1.FontColor.Gray,
    },
};
var Property = (function (_super) {
    __extends(Property, _super);
    function Property() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Property.prototype.render = function () {
        var _a = this.props, defaultValue = _a.defaultValue, description = _a.description, name = _a.name, type = _a.type;
        return (React.createElement("tr", null,
            React.createElement("td", { style: [componentStyle.td, componentStyle.name] }, name),
            React.createElement("td", { style: [componentStyle.td, componentStyle.type] }, type),
            React.createElement("td", { style: [componentStyle.td, componentStyle.defaultValue] }, defaultValue),
            React.createElement("td", { style: componentStyle.td }, description)));
    };
    Property = __decorate([
        Radium
    ], Property);
    return Property;
}(react_1.PureComponent));
exports.Property = Property;



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Properties/Property.tsx
// module id = 625
// module chunks = 0